import { Badge } from '@ordr-as/umami-react/badge';
import { Button } from '@ordr-as/umami-react/button';
import classNames from 'clsx';
import type { MenuSectionDto } from '../../../../generated-api';
import { useSearch } from '../../../context/SearchContext';
import React from 'react';
import { isAdyenDevice } from '../../../utils/isAdyenDevice';

interface MenuSectionButtonProps {
  active: boolean;
  menuSection: MenuSectionDto;
  handleSectionClick: (menuSection: MenuSectionDto) => void;
}

const colorOfItems = (active: boolean) =>
  classNames({
    'bg-purple-lightest text-bold': active,
  });

const MenuSectionButton = (props: MenuSectionButtonProps) => {
  const isLowEndDevice = isAdyenDevice();
  const { active, menuSection, handleSectionClick } = props;
  const { searchText } = useSearch();

  const colorChange = (isActive: boolean) =>
    classNames({
      'animate-colorChange': isActive && !isLowEndDevice,
    });

  const matchCount = menuSection.items.length + menuSection.subsections.reduce((sum, sub) => sum + sub.items.length, 0);

  return (
    <Button
      className={`pl-2 pr-4 py-4 flex flex-row justify-between w-full text-left truncate text-small break-words border-l-[12px] border-l-brand-white ${colorOfItems(
        active
      )} ${colorChange(active)}`}
      styleOverride={{ borderLeftColor: menuSection.eposDisplayColor }}
      key={menuSection.sectionId}
      onClick={() => handleSectionClick(menuSection)}
      size="medium"
    >
      <span className="whitespace-normal">{menuSection.name}</span>
      {searchText.length !== 0 && <Badge text={matchCount.toString()} className="bg-brand-white" />}
    </Button>
  );
};

export default React.memo(MenuSectionButton);
